// @flow
import { Button } from '../buttons';
import generalIcons from '~/core/constants/icons/general-svg';
import SVGIcon from '~/core/icons/svg-icons';
import styled from 'styled-components';

export const SequenceContainer = styled.div`width: 100%;`;

export const SequenceList = styled.ul`
    overflow: hidden;
    list-style: none;
    margin: 0 auto;
    height: 2em;
    width: 100%;
    text-align: center;
`;

export const SequenceItem = styled.li`display: inline-block;`;

export const PaginationDot = styled(SVGIcon).attrs({ type: generalIcons.CIRCLE_OUTLINE })`
    height: 1em;
    width: 1em;
    & g {
        fill: ${props => props.theme.primaryFontColor};
    }
`;

export const PaginationDotActive = PaginationDot.extend.attrs({ type: generalIcons.CIRCLE_FILLED })``;

export const ButtonContainer = styled.div`
    width: 100%;
    margin: 0.5em 0;
`;

export const CancelButton = styled(Button)`
    width: 9em;
    margin: 0 0.5em;
`;

export const NextButton = styled(Button)`
    width: 9em;
    margin: 0 0.5em;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/sequence-carousel/styles.js